/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as UserManagementRouteImport } from './app/routes/user-management'
import { Route as ReportsRouteImport } from './app/routes/reports'
import { Route as ProfileRouteImport } from './app/routes/profile'
import { Route as NotificationsRouteImport } from './app/routes/notifications'
import { Route as MobileOnlyRouteImport } from './app/routes/mobile-only'
import { Route as MapRouteImport } from './app/routes/map'
import { Route as ManualRouteImport } from './app/routes/manual'
import { Route as LoginRouteImport } from './app/routes/login'
import { Route as IssuesRouteImport } from './app/routes/issues'
import { Route as HodRouteImport } from './app/routes/hod'
import { Route as GisRouteImport } from './app/routes/gis'
import { Route as EntitiesRouteImport } from './app/routes/entities'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as UserManagementIndexRouteImport } from './app/routes/user-management.index'
import { Route as IssuesIndexRouteImport } from './app/routes/issues.index'
import { Route as HodIndexRouteImport } from './app/routes/hod.index'
import { Route as EntitiesIndexRouteImport } from './app/routes/entities.index'
import { Route as UserManagementDepartmentsRouteImport } from './app/routes/user-management.departments'
import { Route as UserManagementChangeRequestsRouteImport } from './app/routes/user-management.change-requests'
import { Route as IssuesIssueIdRouteImport } from './app/routes/issues.$issueId'
import { Route as HodIssuesRouteImport } from './app/routes/hod.issues'
import { Route as HodDashboardRouteImport } from './app/routes/hod.dashboard'
import { Route as EntitiesIdRouteImport } from './app/routes/entities.$id'
import { Route as AuthForgotPasswordRouteImport } from './app/routes/auth.forgot-password'
import { Route as HodSitesIndexRouteImport } from './app/routes/hod.sites.index'
import { Route as HodSitesSiteIdRouteImport } from './app/routes/hod.sites.$siteId'
import { Route as EntitiesIdSiteDetailsRouteImport } from './app/routes/entities.$id_.site-details'
import { Route as EntitiesIdResponseDetailsRouteImport } from './app/routes/entities.$id_.response-details'
import { Route as EntitiesIdParticularIssueRouteImport } from './app/routes/entities.$id_.particular-issue'
import { Route as EntitiesIdCreateTemplateRouteImport } from './app/routes/entities.$id_.create-template'
import { Route as HodSitesSiteIdResponseDetailsRouteImport } from './app/routes/hod.sites.$siteId_.response-details'

const UserManagementRoute = UserManagementRouteImport.update({
  id: '/user-management',
  path: '/user-management',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileOnlyRoute = MobileOnlyRouteImport.update({
  id: '/mobile-only',
  path: '/mobile-only',
  getParentRoute: () => rootRouteImport,
} as any)
const MapRoute = MapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => rootRouteImport,
} as any)
const ManualRoute = ManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IssuesRoute = IssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => rootRouteImport,
} as any)
const HodRoute = HodRouteImport.update({
  id: '/hod',
  path: '/hod',
  getParentRoute: () => rootRouteImport,
} as any)
const GisRoute = GisRouteImport.update({
  id: '/gis',
  path: '/gis',
  getParentRoute: () => rootRouteImport,
} as any)
const EntitiesRoute = EntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserManagementIndexRoute = UserManagementIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserManagementRoute,
} as any)
const IssuesIndexRoute = IssuesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IssuesRoute,
} as any)
const HodIndexRoute = HodIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HodRoute,
} as any)
const EntitiesIndexRoute = EntitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EntitiesRoute,
} as any)
const UserManagementDepartmentsRoute =
  UserManagementDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => UserManagementRoute,
  } as any)
const UserManagementChangeRequestsRoute =
  UserManagementChangeRequestsRouteImport.update({
    id: '/change-requests',
    path: '/change-requests',
    getParentRoute: () => UserManagementRoute,
  } as any)
const IssuesIssueIdRoute = IssuesIssueIdRouteImport.update({
  id: '/$issueId',
  path: '/$issueId',
  getParentRoute: () => IssuesRoute,
} as any)
const HodIssuesRoute = HodIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => HodRoute,
} as any)
const HodDashboardRoute = HodDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => HodRoute,
} as any)
const EntitiesIdRoute = EntitiesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => EntitiesRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const HodSitesIndexRoute = HodSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => HodRoute,
} as any)
const HodSitesSiteIdRoute = HodSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => HodRoute,
} as any)
const EntitiesIdSiteDetailsRoute = EntitiesIdSiteDetailsRouteImport.update({
  id: '/$id_/site-details',
  path: '/$id/site-details',
  getParentRoute: () => EntitiesRoute,
} as any)
const EntitiesIdResponseDetailsRoute =
  EntitiesIdResponseDetailsRouteImport.update({
    id: '/$id_/response-details',
    path: '/$id/response-details',
    getParentRoute: () => EntitiesRoute,
  } as any)
const EntitiesIdParticularIssueRoute =
  EntitiesIdParticularIssueRouteImport.update({
    id: '/$id_/particular-issue',
    path: '/$id/particular-issue',
    getParentRoute: () => EntitiesRoute,
  } as any)
const EntitiesIdCreateTemplateRoute =
  EntitiesIdCreateTemplateRouteImport.update({
    id: '/$id_/create-template',
    path: '/$id/create-template',
    getParentRoute: () => EntitiesRoute,
  } as any)
const HodSitesSiteIdResponseDetailsRoute =
  HodSitesSiteIdResponseDetailsRouteImport.update({
    id: '/sites/$siteId_/response-details',
    path: '/sites/$siteId/response-details',
    getParentRoute: () => HodRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/entities': typeof EntitiesRouteWithChildren
  '/gis': typeof GisRoute
  '/hod': typeof HodRouteWithChildren
  '/issues': typeof IssuesRouteWithChildren
  '/login': typeof LoginRoute
  '/manual': typeof ManualRoute
  '/map': typeof MapRoute
  '/mobile-only': typeof MobileOnlyRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRoute
  '/reports': typeof ReportsRoute
  '/user-management': typeof UserManagementRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/entities/$id': typeof EntitiesIdRoute
  '/hod/dashboard': typeof HodDashboardRoute
  '/hod/issues': typeof HodIssuesRoute
  '/issues/$issueId': typeof IssuesIssueIdRoute
  '/user-management/change-requests': typeof UserManagementChangeRequestsRoute
  '/user-management/departments': typeof UserManagementDepartmentsRoute
  '/entities/': typeof EntitiesIndexRoute
  '/hod/': typeof HodIndexRoute
  '/issues/': typeof IssuesIndexRoute
  '/user-management/': typeof UserManagementIndexRoute
  '/entities/$id/create-template': typeof EntitiesIdCreateTemplateRoute
  '/entities/$id/particular-issue': typeof EntitiesIdParticularIssueRoute
  '/entities/$id/response-details': typeof EntitiesIdResponseDetailsRoute
  '/entities/$id/site-details': typeof EntitiesIdSiteDetailsRoute
  '/hod/sites/$siteId': typeof HodSitesSiteIdRoute
  '/hod/sites/': typeof HodSitesIndexRoute
  '/hod/sites/$siteId/response-details': typeof HodSitesSiteIdResponseDetailsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/gis': typeof GisRoute
  '/login': typeof LoginRoute
  '/manual': typeof ManualRoute
  '/map': typeof MapRoute
  '/mobile-only': typeof MobileOnlyRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRoute
  '/reports': typeof ReportsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/entities/$id': typeof EntitiesIdRoute
  '/hod/dashboard': typeof HodDashboardRoute
  '/hod/issues': typeof HodIssuesRoute
  '/issues/$issueId': typeof IssuesIssueIdRoute
  '/user-management/change-requests': typeof UserManagementChangeRequestsRoute
  '/user-management/departments': typeof UserManagementDepartmentsRoute
  '/entities': typeof EntitiesIndexRoute
  '/hod': typeof HodIndexRoute
  '/issues': typeof IssuesIndexRoute
  '/user-management': typeof UserManagementIndexRoute
  '/entities/$id/create-template': typeof EntitiesIdCreateTemplateRoute
  '/entities/$id/particular-issue': typeof EntitiesIdParticularIssueRoute
  '/entities/$id/response-details': typeof EntitiesIdResponseDetailsRoute
  '/entities/$id/site-details': typeof EntitiesIdSiteDetailsRoute
  '/hod/sites/$siteId': typeof HodSitesSiteIdRoute
  '/hod/sites': typeof HodSitesIndexRoute
  '/hod/sites/$siteId/response-details': typeof HodSitesSiteIdResponseDetailsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/entities': typeof EntitiesRouteWithChildren
  '/gis': typeof GisRoute
  '/hod': typeof HodRouteWithChildren
  '/issues': typeof IssuesRouteWithChildren
  '/login': typeof LoginRoute
  '/manual': typeof ManualRoute
  '/map': typeof MapRoute
  '/mobile-only': typeof MobileOnlyRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRoute
  '/reports': typeof ReportsRoute
  '/user-management': typeof UserManagementRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/entities/$id': typeof EntitiesIdRoute
  '/hod/dashboard': typeof HodDashboardRoute
  '/hod/issues': typeof HodIssuesRoute
  '/issues/$issueId': typeof IssuesIssueIdRoute
  '/user-management/change-requests': typeof UserManagementChangeRequestsRoute
  '/user-management/departments': typeof UserManagementDepartmentsRoute
  '/entities/': typeof EntitiesIndexRoute
  '/hod/': typeof HodIndexRoute
  '/issues/': typeof IssuesIndexRoute
  '/user-management/': typeof UserManagementIndexRoute
  '/entities/$id_/create-template': typeof EntitiesIdCreateTemplateRoute
  '/entities/$id_/particular-issue': typeof EntitiesIdParticularIssueRoute
  '/entities/$id_/response-details': typeof EntitiesIdResponseDetailsRoute
  '/entities/$id_/site-details': typeof EntitiesIdSiteDetailsRoute
  '/hod/sites/$siteId': typeof HodSitesSiteIdRoute
  '/hod/sites/': typeof HodSitesIndexRoute
  '/hod/sites/$siteId_/response-details': typeof HodSitesSiteIdResponseDetailsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/entities'
    | '/gis'
    | '/hod'
    | '/issues'
    | '/login'
    | '/manual'
    | '/map'
    | '/mobile-only'
    | '/notifications'
    | '/profile'
    | '/reports'
    | '/user-management'
    | '/auth/forgot-password'
    | '/entities/$id'
    | '/hod/dashboard'
    | '/hod/issues'
    | '/issues/$issueId'
    | '/user-management/change-requests'
    | '/user-management/departments'
    | '/entities/'
    | '/hod/'
    | '/issues/'
    | '/user-management/'
    | '/entities/$id/create-template'
    | '/entities/$id/particular-issue'
    | '/entities/$id/response-details'
    | '/entities/$id/site-details'
    | '/hod/sites/$siteId'
    | '/hod/sites/'
    | '/hod/sites/$siteId/response-details'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/gis'
    | '/login'
    | '/manual'
    | '/map'
    | '/mobile-only'
    | '/notifications'
    | '/profile'
    | '/reports'
    | '/auth/forgot-password'
    | '/entities/$id'
    | '/hod/dashboard'
    | '/hod/issues'
    | '/issues/$issueId'
    | '/user-management/change-requests'
    | '/user-management/departments'
    | '/entities'
    | '/hod'
    | '/issues'
    | '/user-management'
    | '/entities/$id/create-template'
    | '/entities/$id/particular-issue'
    | '/entities/$id/response-details'
    | '/entities/$id/site-details'
    | '/hod/sites/$siteId'
    | '/hod/sites'
    | '/hod/sites/$siteId/response-details'
  id:
    | '__root__'
    | '/'
    | '/entities'
    | '/gis'
    | '/hod'
    | '/issues'
    | '/login'
    | '/manual'
    | '/map'
    | '/mobile-only'
    | '/notifications'
    | '/profile'
    | '/reports'
    | '/user-management'
    | '/auth/forgot-password'
    | '/entities/$id'
    | '/hod/dashboard'
    | '/hod/issues'
    | '/issues/$issueId'
    | '/user-management/change-requests'
    | '/user-management/departments'
    | '/entities/'
    | '/hod/'
    | '/issues/'
    | '/user-management/'
    | '/entities/$id_/create-template'
    | '/entities/$id_/particular-issue'
    | '/entities/$id_/response-details'
    | '/entities/$id_/site-details'
    | '/hod/sites/$siteId'
    | '/hod/sites/'
    | '/hod/sites/$siteId_/response-details'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EntitiesRoute: typeof EntitiesRouteWithChildren
  GisRoute: typeof GisRoute
  HodRoute: typeof HodRouteWithChildren
  IssuesRoute: typeof IssuesRouteWithChildren
  LoginRoute: typeof LoginRoute
  ManualRoute: typeof ManualRoute
  MapRoute: typeof MapRoute
  MobileOnlyRoute: typeof MobileOnlyRoute
  NotificationsRoute: typeof NotificationsRoute
  ProfileRoute: typeof ProfileRoute
  ReportsRoute: typeof ReportsRoute
  UserManagementRoute: typeof UserManagementRouteWithChildren
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user-management': {
      id: '/user-management'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof UserManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-only': {
      id: '/mobile-only'
      path: '/mobile-only'
      fullPath: '/mobile-only'
      preLoaderRoute: typeof MobileOnlyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map': {
      id: '/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manual': {
      id: '/manual'
      path: '/manual'
      fullPath: '/manual'
      preLoaderRoute: typeof ManualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/issues': {
      id: '/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof IssuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hod': {
      id: '/hod'
      path: '/hod'
      fullPath: '/hod'
      preLoaderRoute: typeof HodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gis': {
      id: '/gis'
      path: '/gis'
      fullPath: '/gis'
      preLoaderRoute: typeof GisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities': {
      id: '/entities'
      path: '/entities'
      fullPath: '/entities'
      preLoaderRoute: typeof EntitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-management/': {
      id: '/user-management/'
      path: '/'
      fullPath: '/user-management/'
      preLoaderRoute: typeof UserManagementIndexRouteImport
      parentRoute: typeof UserManagementRoute
    }
    '/issues/': {
      id: '/issues/'
      path: '/'
      fullPath: '/issues/'
      preLoaderRoute: typeof IssuesIndexRouteImport
      parentRoute: typeof IssuesRoute
    }
    '/hod/': {
      id: '/hod/'
      path: '/'
      fullPath: '/hod/'
      preLoaderRoute: typeof HodIndexRouteImport
      parentRoute: typeof HodRoute
    }
    '/entities/': {
      id: '/entities/'
      path: '/'
      fullPath: '/entities/'
      preLoaderRoute: typeof EntitiesIndexRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/user-management/departments': {
      id: '/user-management/departments'
      path: '/departments'
      fullPath: '/user-management/departments'
      preLoaderRoute: typeof UserManagementDepartmentsRouteImport
      parentRoute: typeof UserManagementRoute
    }
    '/user-management/change-requests': {
      id: '/user-management/change-requests'
      path: '/change-requests'
      fullPath: '/user-management/change-requests'
      preLoaderRoute: typeof UserManagementChangeRequestsRouteImport
      parentRoute: typeof UserManagementRoute
    }
    '/issues/$issueId': {
      id: '/issues/$issueId'
      path: '/$issueId'
      fullPath: '/issues/$issueId'
      preLoaderRoute: typeof IssuesIssueIdRouteImport
      parentRoute: typeof IssuesRoute
    }
    '/hod/issues': {
      id: '/hod/issues'
      path: '/issues'
      fullPath: '/hod/issues'
      preLoaderRoute: typeof HodIssuesRouteImport
      parentRoute: typeof HodRoute
    }
    '/hod/dashboard': {
      id: '/hod/dashboard'
      path: '/dashboard'
      fullPath: '/hod/dashboard'
      preLoaderRoute: typeof HodDashboardRouteImport
      parentRoute: typeof HodRoute
    }
    '/entities/$id': {
      id: '/entities/$id'
      path: '/$id'
      fullPath: '/entities/$id'
      preLoaderRoute: typeof EntitiesIdRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hod/sites/': {
      id: '/hod/sites/'
      path: '/sites'
      fullPath: '/hod/sites/'
      preLoaderRoute: typeof HodSitesIndexRouteImport
      parentRoute: typeof HodRoute
    }
    '/hod/sites/$siteId': {
      id: '/hod/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/hod/sites/$siteId'
      preLoaderRoute: typeof HodSitesSiteIdRouteImport
      parentRoute: typeof HodRoute
    }
    '/entities/$id_/site-details': {
      id: '/entities/$id_/site-details'
      path: '/$id/site-details'
      fullPath: '/entities/$id/site-details'
      preLoaderRoute: typeof EntitiesIdSiteDetailsRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/entities/$id_/response-details': {
      id: '/entities/$id_/response-details'
      path: '/$id/response-details'
      fullPath: '/entities/$id/response-details'
      preLoaderRoute: typeof EntitiesIdResponseDetailsRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/entities/$id_/particular-issue': {
      id: '/entities/$id_/particular-issue'
      path: '/$id/particular-issue'
      fullPath: '/entities/$id/particular-issue'
      preLoaderRoute: typeof EntitiesIdParticularIssueRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/entities/$id_/create-template': {
      id: '/entities/$id_/create-template'
      path: '/$id/create-template'
      fullPath: '/entities/$id/create-template'
      preLoaderRoute: typeof EntitiesIdCreateTemplateRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/hod/sites/$siteId_/response-details': {
      id: '/hod/sites/$siteId_/response-details'
      path: '/sites/$siteId/response-details'
      fullPath: '/hod/sites/$siteId/response-details'
      preLoaderRoute: typeof HodSitesSiteIdResponseDetailsRouteImport
      parentRoute: typeof HodRoute
    }
  }
}

interface EntitiesRouteChildren {
  EntitiesIdRoute: typeof EntitiesIdRoute
  EntitiesIndexRoute: typeof EntitiesIndexRoute
  EntitiesIdCreateTemplateRoute: typeof EntitiesIdCreateTemplateRoute
  EntitiesIdParticularIssueRoute: typeof EntitiesIdParticularIssueRoute
  EntitiesIdResponseDetailsRoute: typeof EntitiesIdResponseDetailsRoute
  EntitiesIdSiteDetailsRoute: typeof EntitiesIdSiteDetailsRoute
}

const EntitiesRouteChildren: EntitiesRouteChildren = {
  EntitiesIdRoute: EntitiesIdRoute,
  EntitiesIndexRoute: EntitiesIndexRoute,
  EntitiesIdCreateTemplateRoute: EntitiesIdCreateTemplateRoute,
  EntitiesIdParticularIssueRoute: EntitiesIdParticularIssueRoute,
  EntitiesIdResponseDetailsRoute: EntitiesIdResponseDetailsRoute,
  EntitiesIdSiteDetailsRoute: EntitiesIdSiteDetailsRoute,
}

const EntitiesRouteWithChildren = EntitiesRoute._addFileChildren(
  EntitiesRouteChildren,
)

interface HodRouteChildren {
  HodDashboardRoute: typeof HodDashboardRoute
  HodIssuesRoute: typeof HodIssuesRoute
  HodIndexRoute: typeof HodIndexRoute
  HodSitesSiteIdRoute: typeof HodSitesSiteIdRoute
  HodSitesIndexRoute: typeof HodSitesIndexRoute
  HodSitesSiteIdResponseDetailsRoute: typeof HodSitesSiteIdResponseDetailsRoute
}

const HodRouteChildren: HodRouteChildren = {
  HodDashboardRoute: HodDashboardRoute,
  HodIssuesRoute: HodIssuesRoute,
  HodIndexRoute: HodIndexRoute,
  HodSitesSiteIdRoute: HodSitesSiteIdRoute,
  HodSitesIndexRoute: HodSitesIndexRoute,
  HodSitesSiteIdResponseDetailsRoute: HodSitesSiteIdResponseDetailsRoute,
}

const HodRouteWithChildren = HodRoute._addFileChildren(HodRouteChildren)

interface IssuesRouteChildren {
  IssuesIssueIdRoute: typeof IssuesIssueIdRoute
  IssuesIndexRoute: typeof IssuesIndexRoute
}

const IssuesRouteChildren: IssuesRouteChildren = {
  IssuesIssueIdRoute: IssuesIssueIdRoute,
  IssuesIndexRoute: IssuesIndexRoute,
}

const IssuesRouteWithChildren =
  IssuesRoute._addFileChildren(IssuesRouteChildren)

interface UserManagementRouteChildren {
  UserManagementChangeRequestsRoute: typeof UserManagementChangeRequestsRoute
  UserManagementDepartmentsRoute: typeof UserManagementDepartmentsRoute
  UserManagementIndexRoute: typeof UserManagementIndexRoute
}

const UserManagementRouteChildren: UserManagementRouteChildren = {
  UserManagementChangeRequestsRoute: UserManagementChangeRequestsRoute,
  UserManagementDepartmentsRoute: UserManagementDepartmentsRoute,
  UserManagementIndexRoute: UserManagementIndexRoute,
}

const UserManagementRouteWithChildren = UserManagementRoute._addFileChildren(
  UserManagementRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EntitiesRoute: EntitiesRouteWithChildren,
  GisRoute: GisRoute,
  HodRoute: HodRouteWithChildren,
  IssuesRoute: IssuesRouteWithChildren,
  LoginRoute: LoginRoute,
  ManualRoute: ManualRoute,
  MapRoute: MapRoute,
  MobileOnlyRoute: MobileOnlyRoute,
  NotificationsRoute: NotificationsRoute,
  ProfileRoute: ProfileRoute,
  ReportsRoute: ReportsRoute,
  UserManagementRoute: UserManagementRouteWithChildren,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
